// store/modules/contextMenu.js
export default {
    namespaced: true,
    state: {
        display: false,
        event: null,
        options: {},
        id: null,
        class: null,
    },
    mutations: {
        updateContextMenuDisplay(state, newDisplay) {
            state.display = newDisplay;
        },
        updateContextMenuComponent(state, newComponent) {
            state.component = newComponent;
        },
        updateContextMenuOptions(state, newOptions) {
            state.options = newOptions;
        },
        updateContextMenuId(state, newId) {
            state.id = newId;
        },
        updateContextMenuEvent(state, newEvent) {
            state.event = newEvent;
        },
        updateContextMenuClass(state, newClass) {
            state.class = newClass;
        },
    },
    getters: {
        contextMenuDisplay(state) {
            return state.display;
        },
        contextMenuOptions(state) {
            return state.options;
        },
        contextMenuId(state) {
            return state.id;
        },
        contextMenuEvent(state) {
            return state.event;
        },
        contextMenuClass(state) {
            return state.class;
        },
    },
};
